"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var classcat_1 = require("classcat");
var React = require("react");
var theme = require("./theme.module.scss");
function calculateViewportHeight(viewportRows, hasHeader, hasFooter, itemsCount, rowHeight) {
    return Math.min(viewportRows, Number(itemsCount) + (hasHeader ? 1 : 0) + (hasFooter ? 1 : 0)) * rowHeight;
}
var Virtualized = React.forwardRef(function (_a, ref) {
    var onScroll = _a.onScroll, _b = _a.beforeScrollEndOffset, beforeScrollEndOffset = _b === void 0 ? 200 : _b, onBeforeScrollEnd = _a.onBeforeScrollEnd, extraData = _a.extraData, viewportHeight = _a.viewportHeight, className = _a.className, calculateInitialWidth = _a.calculateInitialWidth, itemsCount = _a.itemsCount, rowHeight = _a.rowHeight, viewportWidth = _a.viewportWidth, viewportRows = _a.viewportRows, _c = _a.overscanItems, overscanItems = _c === void 0 ? 10 : _c, renderRow = _a.renderRow, renderHeader = _a.renderHeader, renderFooter = _a.renderFooter;
    var _d = React.useState([0, 0, 0]), _e = _d[0], scrollTop = _e[0], scrollLeft = _e[1], offsetHeight = _e[2], setScrollPosition = _d[1];
    var _f = React.useState(false), scrollEndOffsetArea = _f[0], setScrollEndOffsetArea = _f[1];
    var _g = React.useState(0), calculatedWidth = _g[0], setCalculatedWidth = _g[1];
    var viewport = ref || React.useRef();
    var containerHeight = React.useMemo(function () { return rowHeight * itemsCount; }, [rowHeight, itemsCount]);
    React.useEffect(function () {
        setScrollPosition([0, 0, viewport.current.offsetHeight]);
    }, []);
    React.useEffect(function () {
        if (calculateInitialWidth) {
            setCalculatedWidth(viewport.current.offsetWidth);
        }
    }, []);
    var onViewportScroll = React.useCallback(function () {
        window.requestAnimationFrame(function () {
            var _a = viewport.current, st = _a.scrollTop, sl = _a.scrollLeft, oh = _a.offsetHeight, scrollHeight = _a.scrollHeight;
            setScrollPosition([st, sl, oh]);
            onScroll && onScroll(st, sl);
            if (onBeforeScrollEnd) {
                if (scrollHeight - (st + oh) <= beforeScrollEndOffset) {
                    !scrollEndOffsetArea && onBeforeScrollEnd(st);
                    setScrollEndOffsetArea(true);
                }
                else if (scrollEndOffsetArea) {
                    setScrollEndOffsetArea(false);
                }
            }
        });
    }, [beforeScrollEndOffset, scrollEndOffsetArea]);
    var calculatedViewportHeight = React.useMemo(function () {
        return viewportHeight
            ? viewportHeight
            : viewportRows
                ? calculateViewportHeight(viewportRows, !!renderHeader, !!renderFooter, itemsCount, rowHeight)
                : "100%";
    }, [viewportRows, viewportHeight, renderHeader, renderFooter, itemsCount, rowHeight]);
    var startItemIndex = Math.floor(scrollTop / rowHeight) - overscanItems;
    startItemIndex = Math.max(0, startItemIndex);
    var visibleItemsCount = Math.ceil(offsetHeight / rowHeight) + 2 * overscanItems;
    visibleItemsCount = Math.min(itemsCount - startItemIndex, visibleItemsCount);
    visibleItemsCount = Math.max(0, visibleItemsCount);
    var offsetY = startItemIndex * rowHeight;
    var visibleArray = React.useMemo(function () { return new Array(visibleItemsCount).fill(null); }, [visibleItemsCount]);
    var classNames = React.useMemo(function () { return classcat_1.default([theme.viewport, className]); }, [className]);
    return (React.createElement("div", { "data-virtualized-scrolled-x": scrollLeft > 0, "data-virtualized-scrolled-y": scrollTop > 0, className: classNames, style: {
            height: calculatedViewportHeight,
            width: viewportWidth || (calculateInitialWidth && calculatedWidth) || ""
        }, ref: viewport, onScroll: onViewportScroll },
        renderHeader && (React.createElement("div", { "data-virtualized-header": true, className: theme.header }, renderHeader(scrollTop, scrollLeft))),
        React.createElement("div", { style: {
                height: containerHeight,
                minWidth: "100%",
                float: "left",
            } },
            React.createElement("div", { style: {
                    willChange: "transform",
                    contain: "layout style paint",
                    transform: "translateY(" + offsetY + "px)",
                } }, visibleArray.map(function (_, viewportIndex) { return renderRow(startItemIndex + viewportIndex, viewportIndex); }))),
        renderFooter && (React.createElement("div", { "data-virtualized-footer": true, className: theme.footer }, renderFooter(scrollTop, scrollLeft)))));
});
exports.default = React.memo(Virtualized);
